import { render, staticRenderFns } from "./ObjectStaticMap.vue?vue&type=template&id=5b83286d&scoped=true&"
import script from "./ObjectStaticMap.vue?vue&type=script&lang=js&"
export * from "./ObjectStaticMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b83286d",
  null
  
)

export default component.exports